import styled from 'styled-components';

export const TutorialTooltip = styled.div`
  position: absolute;
  background: var(--color-text);
  border-radius: 0.4em;
  height: fit-content;
  width: fit-content;

  *::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 13px solid transparent;
    border-bottom-color: var(--color-text);
    border-top: 0;
    margin-left: -12px;
    margin-top: -12px;
  }
`;
